import React from 'react';

import { AsaphButton } from '@/components/shared/Button/AsaphButton';

import styles from './AnalysisGateCard.module.scss';

type Props = {
	body: string;
	ctaLabel: string;
	onCtaClick: () => void;
};

const AnalysisGateCard: React.FC<Props> = ({ body, ctaLabel, onCtaClick }) => {
	return (
		<div className={styles['root']}>
			<div className={styles['body']}>{body}</div>
			<div className={styles['action']}>
				<AsaphButton
					color="blue"
					label={ctaLabel}
					fullWidth
					onClick={onCtaClick}
				/>
			</div>
		</div>
	);
};

export default AnalysisGateCard;
